// Exports the "save" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/save')
//   ES2015:
//     import 'tinymce/plugins/save'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/save/index.js
// module id = Ux5r
// module chunks = 1